
import { Vue, Component } from 'vue-property-decorator';
import XGplayer from '@/components/XGplayer.vue';
import { isWeiXin } from '@/common/ts/common';
import { getUnionId } from '@/api/api';

@Component({
  components: {
    XGplayer,
  },
})
export default class LiveComments extends Vue {
  comments = [
    '我是只化身孤岛的蓝鲸',
    '有着最巨大的身影',
    '鱼虾在身侧穿行',
    '也有飞鸟在背上停',
    '我路过太多太美的奇景',
    '如同伊甸般的仙境',
    '而大海太平太静',
    '多少故事无人倾听',
    '我爱地中海的天晴',
    '爱西伯利亚的雪景',
    '爱万丈高空的鹰',
    '爱肚皮下的藻荇',
    '我在尽心尽力地多情',
    '直到那一天',
    '你的衣衫破旧',
    '而歌声却温柔',
    '陪我漫无目的四处漂流',
    '我的背脊如荒丘',
    '而你却微笑摆首',
    '把它当成整个宇宙',
    '你与太阳挥手',
    '也同海鸥问候',
    '陪我爱天爱地四处风流',
    '只是遗憾你终究',
    '无法躺在我胸口',
    '欣赏夜空最辽阔的不朽',
    '把星子放入眸',
    '我是只化身孤岛的蓝鲸',
    '有着最巨大的身影',
    '鱼虾在身侧穿行',
    '也有飞鸟在背上停',
    '我有着太冷太清的天性',
    '对天上的她动过情',
    '而云朵太远太轻',
    '辗转之后各安天命',
    '我未入过繁华之境',
    '未听过喧嚣的声音',
    '未见过太多生灵',
    '未有过滚烫心情',
    '所以也未觉大洋正中',
    '有多么安静',
    '你的衣衫破旧',
    '而歌声却温柔',
    '陪我漫无目的四处漂流',
    '我的背脊如荒丘',
    '而你却微笑摆首',
    '把它当成整个宇宙',
    '你与太阳挥手',
    '也同海鸥问候',
    '陪我爱天爱地四处风流',
    '只是遗憾你终究',
    '无法躺在我胸口',
    '欣赏夜空最辽阔的不朽',
    '把星子放入眸',
    '你的指尖轻柔',
    '抚摸过我所有',
    '风浪冲撞出的丑陋疮口',
    '你眼中有春与秋',
    '胜过我见过爱过',
    '的一切山川与河流',
    '曾以为我肩头',
    '是那么的宽厚',
    '足够撑起海底那座琼楼',
    '而在你到来之后',
    '它显得如此清瘦',
    '我想给你能奔跑的岸头',
    '让你如同王后',
  ];
  userInput = '';
  chatRoomHeight = 0;
  giftIndex = 0;

  get randomGifts() {
    return this.comments[this.giftIndex];
  }

  mounted() {
    if (isWeiXin()) {
      if (!this.$route.query.code && !localStorage.getItem('gbwxUserInfo')) {
        // 模拟微信授权跳转
        const appId = 'wx1949ed4a473b87ed';
        location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
          location.href,
        )}`;
      } else {
        getUnionId({
          code: this.$route.query.code,
        }).then((res) => {
          localStorage.setItem('gbwxUserInfo', JSON.stringify(res.data));
        });
      }
    }
    // 计算聊天室高度
    const chatRoomElHeight =
      (this.$refs.player as Vue).$el.clientHeight +
      (this.$refs.sectionTitle as HTMLElement).clientHeight +
      (this.$refs.inputArea as HTMLElement).clientHeight;
    this.chatRoomHeight = chatRoomElHeight;
    // 注册定时任务动态改变giftIndex
    this.genGifts();
  }

  genGifts() {
    setTimeout(() => {
      const randomIndex = Math.floor(Math.random() * this.comments.length);
      this.giftIndex = randomIndex;
      this.genGifts();
    }, Math.round(Math.random() * 5000));
  }

  onSubmit() {
    if (!this.userInput) {
      return;
    }
    this.comments.push(this.userInput);
    this.userInput = '';
    // 输入后自动滚到底部
    setTimeout(() => {
      (this.$refs.chatList as HTMLDivElement).scrollTo(
        0,
        (this.$refs.chatList as HTMLDivElement).scrollHeight,
      );
    }, 50);
  }
}
